// 错误码
export const CODE = {
  ERR_NO: 101,
  ERR_USERINFO_INVALID: 102,
  ERR_NO_AUTHOR: 103
}


export const ERR_OK = 1
